<template lang="html">

    <div class="payment-container row-between">


        <h4>Cuanto quieres donar</h4>

        <div class="contenedor-input -radios row-center">
            <div class="radio">
                <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="20"
                    id="amount-20">
                <label for="amount-20"><strong>20</strong> Euros</label>
            </div>
            <div class="radio">
                <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="25"
                    id="amount-25">
                <label for="amount-25"><strong>25</strong> Euros</label>
            </div>
            <div class="radio">
                <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="50"
                    id="amount-50">
                <label for="amount-50"><strong>50</strong> Euros</label>
            </div>
            <div class="radio">
                <input @change="eraseOtherAmount" type="radio" name="amount" v-model="data.amount" value="100"
                    id="amount-100">
                <label for="amount-100"><strong>100</strong> Euros</label>
            </div>

            <div class="contenedor-input">
                <label for="otheramount">Indicar otra cantidad</label>
                <input @change="setOtherAmount" type="text" name="amount" id="otheramount" v-model="data.otheramount"
                    v-validate="'max_value:100'">
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('amount') }}</span>
            </div>

            <span v-if="erroramount" class="error">Por favor, selecciona un importe para donar</span>
        </div>

        <h4>¿Quieres hacer una donación periódica?</h4>

        <div class="contenedor-input row-center">

            <div class="radio-el">
                <input type="radio" name="time" v-model="data.time" :value="0" id="time-no">
                <label for="time-no">No</label>
            </div>

            <div class="radio-el">
                <input type="radio" name="time" v-model="data.time" :value="'1'" id="time-tarjeta">
                <label for="time-tarjeta">Mensual</label>
            </div>

            <div class="radio-el">
                <input type="radio" name="time" v-model="data.time" :value="'2'" id="time-transferencia">
                <label for="time-transferencia">Anual</label>
            </div>

        </div>

        <template v-if="data.time == 0">

            <h4>¿CÓMO QUIERES REALIZAR TU DONACIÓN?</h4>

            <div class="contenedor-input row-center">

                <div class="radio-el">
                    <input type="radio" name="via" v-model="data.via" :value="'tarjeta'" id="via-tarjeta">
                    <label for="via-tarjeta">Pago con tarjeta</label>
                </div>

                <div class="radio-el">
                    <input type="radio" name="via" v-model="data.via" :value="'transferencia'" id="via-transferencia">
                    <label for="via-transferencia">Transferencia</label>
                </div>

            </div>

        </template>


        <template v-if="cards.length != 0 && data.via == 'tarjeta'">

            <h4>Mis tarjetas</h4>

            <div class="cards-container">
                <div class="card-list" v-if="cards.length != 0">
                    <div class="contenedor-input column-center">
                        <div class="radio-el" v-for="(card,key) in cards">
                            <input type="radio" :value="card.id" :id="card.id" name="card" v-model="data.cardId">
                            <label :for="card.id">**** **** **** {{card.card.last4}}</label>
                        </div>
                    </div>
                    <a v-if="!!!showcard" @click="setshowcard" class="showaddcard">Pagar con otra tarjeta</a>
                </div>

            </div>

        </template>

        <div class="contenedor-tarjeta" v-show="(cards.length == 0 || showcard) && data.via == 'tarjeta'">
            <h4>Introduce tu tarjeta</h4>
            <div class="contenedor-input">
                <label for="card-element">Número de tarjeta</label>
                <div id="card-element"></div>
            </div>

            <p class="card-error" v-if="!!errormessage">{{errormessage}}</p>
        </div>

        <h4>Introduce tus datos</h4>




        <div class="contenedor-input">
            <label for="name">{{(data.type == 'particular') ? 'Nombre' : 'Nombre de la empresa'}}</label>
            <input type="text" name="name" id="name" v-model="data.name" v-validate="'required'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('name') }}</span>
        </div>

        <div class="contenedor-input" v-if="data.type == 'particular'">
            <label for="surnames">Apellidos</label>
            <input type="name" name="surnames" id="surnames" v-model="data.surnames" v-validate="'required'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('surnames') }}</span>
        </div>

        <div class="contenedor-input -middle">
            <label for="dni">{{(data.type == 'particular') ? 'DNI' : 'CIF'}}</label>
            <input type="dni" name="dni" id="dni" v-model="data.dni" v-validate="'required|nif'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('dni') }}</span>
        </div>

        <div class="contenedor-input -middle">
            <label for="phone">Teléfono</label>
            <input type="phone" name="phone" id="phone" v-model="data.phone" v-validate="'required'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('phone') }}</span>
        </div>

        <div class="contenedor-input">
            <label for="email">Email</label>
            <input type="email" name="email" id="email" v-model="data.email" v-validate="'required|email'">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
        </div>


        <div class="contenedor-input -middle">
            <label for="postal_code">Código postal*</label>
            <input type="text" name="postal_code" id="postal_code" v-model="data.postal_code" v-validate="'required|postal_code'" maxlength="5">
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('postal_code') }}</span>
        </div>


        <div class="contenedor-input" v-if="legaltext[0]">
            <input type="checkbox" class="input-check" v-validate="'required'" id="politica-contacto" name="politica"
              :placeholder="$t('formulario.telefono')" @change="generatehash" :hash="legaltext[0].hash"/>
            <label for="politica-contacto" v-html="legaltext[0].Texto"></label>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
          </div>
      
        <div class="contenedor-input" v-if="legaltext[1]">
            <input type="checkbox" class="input-check" id="newsletter" name="newsletter" v-model="data.newsletter" @change="generatehash" :hash="legaltext[1].hash"/>
            <label for="newsletter" v-html="legaltext[1].Texto"></label>
          </div>

        <input type="hidden" name="hash" id="hash" v-model="hash_1">
        <input type="hidden" name="hash_2" id="hash_2" v-model="hash_2">
        <input type="hidden" name="mia" value="FM-FUNDACIONTOMASPASCUAL CONTACTOWEB DOUBLEDOT">


        <div class="contenedor-boton row-center">
            <button @click="validateBeforeSubmit" class="btn red" :loading="loading">Hacer
                donación</button>
        </div>





    </div>

</template>

<script lang="js">

    import { mapActions, mapGetters } from 'vuex';

    import axios from 'axios'
    import includeStripe from '@/utils/includeStripe'

    export default {
        name: 'payment',
        props: ['id'],
        mounted() {
            includeStripe('js.stripe.com/v3/', () => {
                this.configureStripe();
            });

            if (!!this.id) {
                this.data.project_id = this.id;
            }


            if (this.isLogged) {
                this.getData();
            }

            this.setdata();

        },
        data() {
            return {
                stripeAPIToken: 'pk_live_51Iw1iqIjMOewFaa7Csm7GOio4yg2pF2igwNhAxmpPQ9g60tsJVnLis3qiAzhaVACuEeYGPejaQemsMmYaPXIs2Ky00wksWdg8m',
                stripe: '',
                elements: '',
                cardvalid: false,
                errormessage: '',
                card: '',
                prButton: '',
                clicked: false,
                loading: false,
                erroramount: false,
                cards: '',
                user: '',
                showcard: false,
                data: {
                    otheramount: '',
                    amount: '',
                    email: '',
                    street: '',
                    postal_code: '',
                    project_id: '',
                    time: 0,
                    type: 'particular',
                    newsletter: false,
                    hash: [],
                    mia: 'FM-FUNDACIONTOMASPASCUAL CONTACTOWEB DOUBLEDOT'
                },
                response: '',
                legaltext: [],
                hash_1: '',
                hash_2: '',
                legales: [
                    {
                        label: "politica-contacto",
                        input: "politica-contacto",
                        clave: "PP-FUNDACIONTOMASPASCUAL DONACIONWEB ES DOUBLEDOT",
                        enlaces: [
                            `/politica-de-privacidad`,
                        ]
                    },
                    {
                        label: "newsletter",
                        input: "newsletter",
                        clave: "EC-FUNDACIONTOMASPASCUAL DONACIONWEB ES DOUBLEDOT",
                    }
                ]
            }
        },
        computed: {
            ...mapGetters({
                isLogged: 'getLogged'
            })
        },
        methods: {
            ...mapActions(['makePayment', 'makePaymentManual', 'eraseProject', 'requestcards', 'requestuser', 'makeIntentSave', 'createSubscription', 'setError']),
            configureStripe() {

                this.stripe = Stripe(this.stripeAPIToken);
                this.elements = this.stripe.elements();
                this.card = this.elements.create(
                    'card',
                    {
                        hidePostalCode: true,
                        style: {
                            base: {
                                fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                                fontSize: '16px',
                                fontSmoothing: 'antialiased',
                                ':-webkit-autofill': {
                                    color: '#000000',
                                    backgroundColor: '#ffffff',
                                },
                                '::placeholder': {
                                    color: '#64686b',
                                },
                            },
                        },
                    }
                );
                this.card.mount('#card-element');


                this.card.on('change', event => {
                    if (event.complete) {
                        this.cardvalid = true;
                        this.errormessage = '';
                        this.data.cardId = '';
                    } else if (event.error) {
                        this.errormessage = event.error.message;
                    } else if (!!!event.error) {
                        this.errormessage = '';
                    }
                });
            },
            getData() {
                this.requestcards().then(r => {
                    this.cards = r;
                });

                this.requestuser().then(r => {
                    this.data.email = r.email;
                    this.data.phone = r.phone;
                })

            },
            validateBeforeSubmit: function () {
                this.clicked = true;
                if (this.data.dni) this.data.dni = this.data.dni.toUpperCase().trim();
                if (this.data.postal_code) this.data.postal_code = this.data.postal_code.trim();
                this.erroramount = (!!!this.data.amount);
                this.$validator.validateAll().then(canSend => {

                    if (!!!this.data.cardId) {
                        if (canSend && (this.cardvalid || this.data.via == 'transferencia') && !this.erroramount) {
                            this.requestPayment();
                        }
                    } else {
                        if (canSend) {
                            this.requestPayment();
                        }
                    }

                });
            },
            requestPayment() {
                this.loading = true;


                if (this.data.time == 0) {
                    if (this.data.via == "tarjeta") {
                        this.makePayment(this.data).then(r => {
                            if (!!!this.data.cardId) {
                                this.validatePayment(r);

                            } else {
                                this.stripe.confirmCardPayment(r, {}).then(result => {

                                    this.loading = false;
                                    if (result.error) {
                                        this.setError("makePayment");
                                    } else {
                                        this.$router.push('/gracias/tarjeta')
                                        this.eraseProject();
                                    }
                                }).catch(e => {
                                    console.log(e);
                                })
                            }
                        });

                    } else {

                        this.makePaymentManual(this.data).then(r => {
                            if (r) {
                                this.$router.push('/gracias/transferencia');
                                this.loading = false;
                            }
                        });
                    }

                } else {

                    this.data.via = "tarjeta";

                    this.makeIntentSave().then(r => {
                        this.client_secret = r;
                        this.validateCard(r).then(r => {
                            this.loading = false;
                        });
                    });

                }

            },
            validatePayment(client_secret) {
                this.stripe.confirmCardPayment(client_secret, {
                    payment_method: {
                        card: this.card,
                    }
                }).then(result => {

                    this.loading = false;
                    if (result.error) {
                        this.setError("makePayment");
                    } else {
                        this.$router.push('/gracias/tarjeta')
                        this.eraseProject();
                    }
                }).catch(e => {
                    console.log(e);
                })
            },
            setshowcard() {
                this.showcard = true;
                this.data.cardId = '';
            },
            setOtherAmount() {
                if (!!this.data.otheramount) {
                    this.data.amount = this.data.otheramount.replace(/\,/g, '.');
                }
            },
            eraseOtherAmount() {
                if (!!this.data.amount) {
                    this.data.otheramount = '';
                }
            },
            validateCard(client_secret) {
                this.stripe.confirmCardSetup(client_secret, {
                    payment_method: {
                        card: this.card,
                        billing_details: { name: this.data.name }
                    }
                }).then(result => {
                    if (result.error) {
                        this.setError("makePayment");
                    } else {
                        this.data.payment_method = result.setupIntent.payment_method;
                        
                        this.createSubscription(this.data).then(r => {
                            if (r) {
                                this.$router.push('/gracias/tarjeta')
                            }
                        });
                        
                    }
                }).catch(e => {
                    console.log(e);
                })
            },
            setdata() {


                this.legales.forEach(texto => {
                    axios.get(`https://apin-datahub-prod-001.azure-api.net/api/texto-legal/${texto.clave}?area_mkt_desc=Fundación%20TPPGC`).then(result => {
                        var dom = document.createElement('span');
                        dom.innerHTML = result.data.Texto;

                        if (dom.querySelector('a')) {
                            dom.querySelector('a').href = texto.enlaces[0];
                        }

                        result.data.Texto = dom.innerHTML;

                        result.data.hash = result.data.Texto_Legal_Id + ";" + result.data.Hash_Version_Id + ";" + 'FUNDACION TOMAS PASCUAL';

                        this.legaltext.push(result.data);
                    });
                })

            },
            generatehash(event) {
                var status = {};
                var hashValue = "";

                this.legales.forEach((texto) => {
                    status[texto.input] = document.getElementById(texto.input).checked;
                });

                Object.keys(status).forEach((check) => {
                    hashValue += (status[check]) ? $(`#${check}`).attr('hash') + "#" : "";
                });

                hashValue = hashValue.substr(0, hashValue.length - 1);
                this.hash_1 = hashValue.substr(0, 500);
                if (hashValue.length > 500) {
                    this.hash_2 = hashValue.substr(
                        500,
                        hashValue.length
                    );
                }

                if (this.hash_1) {
                    this.data.hash.push(this.hash_1);
                }
                if (this.hash_2) {
                    this.data.hash.push(this.hash_2);
                }
            }


        },
        watch: {
            'data.time'() {
                if (this.data.time != 0) {
                    this.data.via = 'tarjeta';
                }
            }
        }
    }

</script>


<style lang="scss">
    .payment-container {
        .card-list {
            max-width: 300px;

            .contenedor-input {
                margin-bottom: 0;
                padding-bottom: 0;
                margin-top: 0;
            }

        }
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/payment.vue